/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'

import firebase from 'firebase';

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [

        {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
              {
                path: '/',
                name: 'almacen',
                component: () => import('./views/Almacen.vue'),
                meta: {
                  requiresAuth: true
                }
              },
              {
                path: '/tinas',
                name: 'tinas',
                component: () => import('./views/Tinas.vue'),
                meta: {
                  requiresAuth: true
                }
              },
              {
                path: '/tinas2',
                name: 'tinas',
                component: () => import('./views/TinasLight.vue'),
                meta: {
                  requiresAuth: true
                }
              },
              {
                path: '/descargas',
                name: 'descargas',
                component: () => import('./views/descargas.vue'),
                meta: {
                  requiresAuth: true
                }
              },
              {
                path: '/pages/error-404',
                name: 'page-error-404',
                component: () => import('@/views/pages/Error404.vue'),
                meta: {
                  requiresGuest: true
                }
              }
            ],
        },
      //
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
        // Redirect to 404 page, if no match found
      {
        path: '/logout',
        name: 'logout',
        component: () => import('@/views/Logout.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/login',
        name: 'login',
        component: () => import('@/views/Login.vue'),
        meta: {
          requiresGuest: true
        }
      },
      {
            path: '*',
            // redirect: '/pages/error-404'
            redirect: '/login'
        }
    ],
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
});

// Nav Guards
router.beforeEach((to, from, next) => {
  // Check for requiredAuth guard
  if(to.matched.some(record => record.meta.requiresAuth)) {
  //  Check if NOT logged in
    if (!firebase.auth().currentUser) {
    //  Go to login page
      next({
        path: '/login',
        query: {
            redirect: to.fullPath
        }
      });
    } else {
      // Proceed to the route
      next();
    }
  } else if(to.matched.some(record => record.meta.requiresGuest)) {
    // Check if logged in
    if (firebase.auth().currentUser) {
      //  Go to login page
      next({
        path: '/',
        query: {
          redirect: to.fullPath
        }
      });
    } else {
      // Proceed to the route
      next();
    }
  } else {
    // Proceed to the route
    next();
  }
});


export default router;
